import { useTranslation } from 'react-i18next';
import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from '@material-ui/core';
export default function LightTimeChangeDialog({ affected = [], onCancel, onContinue }) {
  const { t } = useTranslation();
  return (
    <Dialog
      open={affected.length > 0}
      onClose={onCancel}
      aria-labelledby="light-time-warning-title"
    >
      <DialogTitle id="light-time-warning-title">
        {t('lighting_time_warning_title', {
          defaultValue: 'Changing Time will invalidate light profiles'
        })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('lighting_time_warning', {
            defaultValue:
              'These day/night times will make the following light profiles invalid. Affected zones will use Simple lighting until the profiles are valid again. Advanced settings will be preserved. Do you want to continue?'
          })}
        </DialogContentText>
        <ul>
          {affected.map((c, index) => (
            <li key={`${c.channel}-${index}`}>
              {t('lighting_zone', {
                defaultValue: 'Zone'
              })}
              {Number(c.zone) + 1}
              {c.phase ? ` · ${c.phase}` : ''} · {c.label}: {c.error}
            </li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>
          {t('lighting_cancel', {
            defaultValue: 'Cancel'
          })}
        </Button>
        <Button onClick={onContinue} color="primary">
          {t('lighting_continue', {
            defaultValue: 'Continue'
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
